import React from 'react';
import { Button, Carousel } from 'antd';
import DiagramUtils from '../../utils/DiagramUtils';
import DiagramUI from "../DiagramUI";
import Model from "./CarouselModel";

export default class UI extends DiagramUI {

    state = {
        height: 0
    };

    constructor(props, context) {
        super(props, context);
    }
    componentDidMount() {
        super.componentDidMount();
        let height = this.rootRef.clientHeight;
        this.setState({
            height: height
        })
    }
    onPropertyValueChanged(name, valOld, valNew, subName) {
        // if (['height','margin'].indexOf(name) > -1) {
        //     let height = this.props.model._sys.height;
        //     console.log(height)
        //     this.setState({
        //         height: height
        //     })
        // }
    }
    render() {
        // let { height } = this.state;
        let { imageSet, autoplay, autoplaySpeed, widthFill, heightFill } = this.props.model;
        const style = this.props.model.toStyle();
        let carouselProps = {};
        if (autoplay) {
            carouselProps = {
                autoplay,
                autoplaySpeed: autoplaySpeed || 2000
            }
        }
        if (autoplay) {
            setTimeout(() => { // 此处autoplay由关闭切换到打开时没有作用
                let event = new Event('resize');
                window.dispatchEvent(event);
            }, 200);
        }
        let withSize = '100%', heightSize = 'auto';
        if (!widthFill) {
            withSize = 'auto';
        }
        if (heightFill) {
            heightSize = '100%';
        }
        // let height = this.props.model._sys.height;
        let height = this.rootRef && this.rootRef.clientHeight || this.state.height;
        return (
            <div className={"diagram-ui " + (this.props.className || "")} style={{
                ...style,
                height: "100%",
                overflow: "hidden"
            }} ref={ref => this.rootRef = ref}>
                <Carousel {...carouselProps}>
                    {imageSet.map((image, index) => {
                        return <div className="img-content" key={index}>
                            <div className="img" style={{
                                height: height
                            }}>
                                <div style={{
                                    backgroundImage: `url(${image})`,
                                    height: height,
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: `${withSize} ${heightSize}`
                                }}></div>
                            </div>
                        </div>
                    })}
                </Carousel>
            </div>
        );
    }
}

const type = new Model().getType();
DiagramUtils.register(type, {
    model: Model,
    name: type,
    alias: "轮播图",
    catalog: "其他",
    svg: "#anticon-share_card",
    uiGetter: (model) => <UI model={model} />
});